import React, { useEffect, useRef, useState } from 'react'
import './quests-list.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faPlus } from '@fortawesome/free-solid-svg-icons';
import SearchBar from '@/components/SHARED/search-bar/search-bar.component';
import CategoryFilterModal from '../components/category-filter-modal.component';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import ManagerElementListItem from '@/components/SHARED/manager-element-list-item/manager-element-list-item.component';
import ManagerElementListMenu from '@/components/SHARED/manager-element-list-menu/manager-element-list-menu.component';
import { sortElementsNoThe } from '@/utils/sortElements';
import { useEffectiveMembership } from '@/utils/useEffectiveMembership';

const QuestsList = ({
    gameElements,
    questsFromDb,
    gameData,
    role
}) => {
    
    const screenSize = useSelector(state => state.contentData.screenSize);
    const membership = useEffectiveMembership();
    const [ showFilterModal, setShowFilterModal ] = useState(false);
    const [ filteredElements, setFilteredElements ] = useState([]);
    const [ contentToDisplay, setContentToDisplay ] = useState([]);
    const [ categoryList, setCategoryList] = useState([]);
    const [ selectedCategories, setSelectedCategories ] = useState([]);
    const [ showUpgradeModal, setShowUpgradeModal ] = useState(null);
    const [ menuCategory, setMenuCategory ] = useState('visible');
    const [ confirmMessage, setConfirmMessage ] = useState(null);
    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ dropdown, setDropdown ] = useState(null);
    const catRef = useRef([]);
    const approveRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        chooseCategory();
    }, [filteredElements])

    function checkMembership() {
        const res = testMemberRestrictions({'gameData':gameData, 'membership':membership, 'create': true});
        if (res.disabled && res.disabledReason.includes('elements')) {
            const planRest = membershipRestrictions[membership.membership];
            const message = `While using the ${planRest.title}, you are only able to have ${planRest.elementCount} active Game Elements per game.`;
            setShowUpgradeModal(message);
            return;
        }
        navigate('create');
    }

    function chooseCategory(e) {
        if (e) {
            let catList = [...catRef.current];
            if (catList.includes(e)) {
                catList.splice(catList.indexOf(e), 1)
            } else {
                catList.push(e)
            }
            catRef.current = catList;
            setSelectedCategories(catRef.current);
        }
        if (catRef.current.length > 0) {
            setContentToDisplay(
                sortElementsNoThe(filteredElements.filter(a => catRef.current.includes(a.opt_cat))))    
        } else {
            setContentToDisplay(sortElementsNoThe(filteredElements))
        }
    }

    function search(e) {
        if (!e) {
            setContentToDisplay(sortElementsNoThe(filteredElements.filter(a => a.type === 'quest')))
            return;
        }
        setContentToDisplay(sortElementsNoThe(filteredElements.filter(a => a.type === 'quest' && (a.name.toLowerCase().includes(e) || a.desc && a.desc.toLowerCase().includes(e)))))
    }
    
    return (
        <div className={`quests-list ${screenSize}`}>
            {
                (screenSize !== 'mobile') &&
                <ManagerElementListMenu
                    gameElements={gameElements}
                    elementsFromDb={questsFromDb}
                    type='quest'
                    setContentToDisplay={setContentToDisplay}
                    setDropdown={setDropdown}
                    setSelectedCategories={setSelectedCategories}
                    setFilteredElements={setFilteredElements}
                    setCategoryList={setCategoryList}
                    menuCategory={menuCategory}
                    setMenuCategory={setMenuCategory}
                    catRef={catRef} />
            }
            {/* <div className="g-space-2"></div> */}
            <div className='quests-list-div'>
                <div className='buttons'>
                    <button
                        className={`g-button med-btn ${role !== 'manager' && role !== 'owner' ? 'disabled' : ''}`}
                        onClick={() => checkMembership()} >
                        Create a Quest
                        <FontAwesomeIcon icon={faPlus} />
                    </button>
                </div>
                 {
                    (screenSize === 'mobile') &&
                    <>
                    <div className="g-space-1"></div>
                    <ManagerElementListMenu
                        gameElements={gameElements}
                        elementsFromDb={questsFromDb}
                        type='quest'
                        setContentToDisplay={setContentToDisplay}
                        setDropdown={setDropdown}
                        setSelectedCategories={setSelectedCategories}
                        setFilteredElements={setFilteredElements}
                        setCategoryList={setCategoryList}
                        menuCategory={menuCategory}
                        setMenuCategory={setMenuCategory}
                        catRef={catRef} />
                    </>
                }
                <div className="g-space-1"></div>
                {/* {
                    (screenSize === 'mobile' || screenSize === 'tablet') &&
                    <>
                    <h3>{properCase(menuCategory)}</h3>
                    <hr />
                    </>
                } */}
                <div className='quests-list-search'>
                    <SearchBar search={search} />
                    <button 
                        type='button' 
                        className='g-button med-btn' 
                        title='Filter by Category'
                        onClick={() => setShowFilterModal(true)} >
                        <FontAwesomeIcon 
                            icon={faFilter}
                            className={selectedCategories.length > 0 ? 'full' : 'empty'} 
                        />
                    </button>
                    {/* <button 
                        type='button' 
                        className='g-button med-btn' 
                        title='Create a New Quest' 
                        onClick={() => checkMembership()} >
                        <FontAwesomeIcon icon={faPlus} />
                    </button> */}
                </div>
                
                <div className="g-space-1"></div>
                {
                    (screenSize !== 'mobile' && screenSize !== 'tablet') &&
                    <>            
                    <div className='g-list-item quests-list-head element-list-row meta'>
                        <div></div>
                        <div>Name</div>
                        {/* <div>Instructions</div> */}
                        <div>Status</div>
                        <div></div>
                    </div>
                    <div className='g-space-0-5'></div>
                    </>
                }
                <div className='quests-list'>
                    {
                        (contentToDisplay.length > 0)
                        ?
                        contentToDisplay
                        // .sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                        .map(c => {
                            let now = new Date().getTime();
                            let status = 'Available';
                            if (c.opt_dateOpen && now < c.opt_dateOpen) {
                                status = 'Date Locked';
                            }
                            if (c.opt_dateClose && now > c.opt_dateClose) {
                                status = 'Beyond Close Date';
                            }
                            if (c.opt_visible === false) {
                                status = 'Hidden';
                            }
                            if (c.checkpoints.some(ch => ch.status !== 'active')) {
                                status = 'Incomplete Checkpoints';
                            }
                            if (c.status !== 'active') {
                                status = 'Deleted';
                            }
                            return (
                            <div key={c.id}>
                                <ManagerElementListItem
                                    gameElements={gameElements}
                                    element={c}
                                    gameData={gameData}
                                    dropdown={dropdown}
                                    setDropdown={setDropdown}
                                    dataPoint={status}
                                    role={role} />
                                </div>
                        )})
                        :
                        <p>No Quests yet...</p>
                    }
                </div>
            </div>


            <CategoryFilterModal 
                show={showFilterModal} 
                cancel={() => setShowFilterModal(false)} 
                chooseCategory={chooseCategory} 
                categoryList={categoryList} 
                selectedCategories={selectedCategories} 
                color='var(--quests-color)'
            />
            <UpgradeRequiredModal
                show={showUpgradeModal}
                cancel={() => setShowUpgradeModal(false)}
                closeButton={true}
                message={showUpgradeModal}
            />
            <ModalConfirm
                show={confirmMessage}
                cancel={() => setConfirmMessage(null)}
                message={confirmMessage}
                onApprove={approveRef.current} />
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage} />
        </div>
    )
}

export default QuestsList